import * as React from 'react';

const SendMessageIcon = ({fillColor = '#2d2756'}) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.70997 4.89658L18.27 9.17658C22.11 11.0966 22.11 14.2366 18.27 16.1566L9.70997 20.4366C3.94997 23.3166 1.59997 20.9566 4.47997 15.2066L5.34997 13.4766C5.56997 13.0366 5.56997 12.3066 5.34997 11.8666L4.47997 10.1266C1.59997 4.37658 3.95997 2.01658 9.70997 4.89658Z"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.64014 12.6666H11.0401"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SendMessageIcon;
